import { alpha, getLuminance } from '@mui/material';

export const isLightColor = (backgroundColor: string) => {
  return getLuminance(backgroundColor) <= 0.14;
};

export const generateTheme = (defaultColors: BrandColors) => {
  const isLightTheme = defaultColors.palette === 'light';

  const onAccentColor =
    defaultColors.onAccentColor ??
    (isLightColor(defaultColors.accentColor) ? '#030712' : '#fafafa');

  return <MTFTheme>{
    palette: defaultColors.palette,
    global: {
      backgroundColor: defaultColors.backgroundColor,
      accentColor: defaultColors.accentColor,
      textColor: defaultColors.textColor,
      subtitleColor: alpha(defaultColors.textColor, 0.5),
      onAccentColor,
    },
    performance: {
      positive: defaultColors.performance?.positive
        ? defaultColors.performance?.positive
        : '#007D14',
      negative: defaultColors.performance?.negative
        ? defaultColors.performance?.negative
        : '#b91c1c',
      neutral: defaultColors?.performance?.neutral
        ? defaultColors?.performance?.neutral
        : '#6b7280',
    },
  };
};
export interface MTFTheme {
  palette: string;
  global: Global;
  performance: Partial<Performance>;
}

interface Performance {
  positive: string;
  negative: string;
  neutral: string;
}

interface Global {
  backgroundColor: string;
  accentColor: string;
  textColor: string;
}

export type BrandColors = Partial<MTFTheme> & {
  palette: string;
  backgroundColor: string;
  textColor: string;
  accentColor: string;
  onAccentColor?: string;
};
